/** A link that leads nowhere: say so plainly and offer the ways back. */
import { useState } from "react";
import { useNavigate } from "react-router";
import { qs } from "../../lib/api";
import { t, useLanguage } from "../../lib/i18n";
import { Button, Icon, TextInput } from "../../ui/kit";
import { Page } from "../Layout";

export function NotFound({ title, body }: { title?: string; body?: string }) {
  useLanguage();
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  return (
    <Page>
      <div className="not-found">
        <span className="empty-icon"><Icon name="notFound" size={28} /></span>
        <h1>{title ?? t("We couldn't find that page")}</h1>
        <p className="muted">{body ?? t("The link may be old, or the record was merged or removed. Search for it, or go back to Today.")}</p>
        <form className="not-found-search" role="search" onSubmit={(e) => { e.preventDefault(); if (q.trim()) navigate(`/search${qs({ q: q.trim() })}`); }}>
          <div className="search-input"><Icon name="search" size={18} /><TextInput value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("Tag, name, place or job")} aria-label={t("Search the ranch")} /></div>
          <Button type="submit" variant="primary">{t("Search")}</Button>
        </form>
        <div className="row-actions">
          <Button icon="today" to="/">{t("Today")}</Button>
          <Button icon="cattle" to="/cattle">{t("Cattle")}</Button>
          <Button icon="work" to="/work">{t("Work")}</Button>
          <Button icon="ranch" to="/ranch">{t("Ranch")}</Button>
        </div>
      </div>
    </Page>
  );
}
